export const DIALOG_TRANSITION_DURATION = 200;
export const INTERVAL_REQUEST_NOTIFICATIONS = 300000;
export const MAX_TEXT_AREA_LENGTH = 5000;
export const TOAST_NOTIFICATION_TIME = 8000;
export const ERROR_CODE_NEW_VERSION_DATA = 406;
export const TIMEOUT_CHECK_TREE_VERSION = 10000;
export const MAX_LENGTH_BY_FOLDER = 250; //longitud máxima para nombres que van a ir en carpetas de ficheros

export const MENU_MODE_AREA = "MENU_AREA"; //menú del área de negocio
export const MENU_MODE_SOCIETY = "MENU_SOCIETY"; //menú para la unidad de negocio
export const MENU_MODE_MIX = "MENU_MIX"; //menú si el usuario pertenece a un área de negocio y a un área

export const CAPTCHA_KEY = "6LekoBIpAAAAAHeEuDGnzWiAxsnHinXRNaBQPIES";

export const MONTHS = [
  {
    value: 0,
    text: "months.january",
  },
  {
    value: 1,
    text: "months.february",
  },
  {
    value: 2,
    text: "months.march",
  },
  {
    value: 3,
    text: "months.april",
  },
  {
    value: 4,
    text: "months.may",
  },
  {
    value: 5,
    text: "months.june",
  },
  {
    value: 6,
    text: "months.july",
  },
  {
    value: 7,
    text: "months.august",
  },
  {
    value: 8,
    text: "months.september",
  },
  {
    value: 9,
    text: "months.october",
  },
  {
    value: 10,
    text: "months.november",
  },
  {
    value: 11,
    text: "months.december",
  },
];

export const COUNTRIES = [
  {
    iso: "MX",
    color: "#8bc34a",
    code: "484",
  },
  {
    iso: "PE",
    color: "#f44336",
    code: "604",
  },
  {
    iso: "ES",
    color: "#fbc02d",
    code: "724",
  },
  {
    iso: "CL",
    color: "#3949ab",
    code: "152",
  },
  {
    iso: "CO",
    color: "#512da8",
    code: "804",
  },
  {
    iso: "IT",
    color: "#009688",
    code: "380",
  },
  {
    iso: "AR",
    color: "#00bcd4",
    code: "320",
  },
  {
    iso: "BR",
    color: "#cddc39",
    code: "521",
  },
  {
    iso: "GB",
    color: "#546e7a",
    code: "826",
  },
];
export const LANGS = [
  {
    value: "en",
    text: "langs.en",
  },
  {
    value: "es",
    text: "langs.es",
  },
  {
    value: "it",
    text: "langs.it",
  },
];

export const GROUP_LEGAL = "LEGAL";

// export const LEGAL_APPS = ["SOGO", "KATALYST", "DOCJURID", "QRIA"];
